module.exports = __webpack_public_path__ + "static/media/Header_Image_002_Tablet.ad480a91.png";